module.exports = __webpack_public_path__ + "img/mars-double.f46f3031.svg";